/*
 * create by nguyendx 2017/10/05
 */
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { HelperModule } from "../../../../common/helper/helper.module";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { IdentifierService } from "./identifier.service";
import { BsDatepickerModule } from "ngx-bootstrap";
import { SelectModule } from "ng-select";
import { ImageService } from "../../../imageService";
import { Log_identifierComponent } from './log_identifier.component';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    BsDatepickerModule.forRoot(),
    SelectModule,
    FilterProductsModule,
    TranslateModule,
  ],
  declarations: [Log_identifierComponent],
  exports: [Log_identifierComponent],
  providers: [IdentifierService, ImageService],
})
export class IdentifierModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/identifier/identifier.module.ts